import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { cleanName, orNull } from '../../../common/utils/text';
import { useCreateLab } from '../contexts/labs';
import { validateLab } from '../utils/validate';
import LabFields from './fields';

import '../../../common/styles/catalog.css';

const EMPTY = { name: '', location: '' };

export default function CreateLabForm() {
    const navigate = useNavigate();
    const { mutateAsync, isPending } = useCreateLab();

    const [form, setForm] = useState(EMPTY);
    const [localErrors, setLocalErrors] = useState({});
    const [serverFields, setServerFields] = useState({});

    const setField = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
        if (localErrors[field] || serverFields[field]) {
            setLocalErrors(prev => ({ ...prev, [field]: undefined }));
            setServerFields(prev => ({ ...prev, [field]: undefined }));
        }
    };
    const fieldError = (field) => localErrors[field] || serverFields[field];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateLab(form);
        if (Object.keys(errors).length) { setLocalErrors(errors); return; }
        setLocalErrors({});
        setServerFields({});

        try {
            await mutateAsync({ name: cleanName(form.name), location: orNull(form.location) });
            toast.success('Laboratorio creado');
            navigate('/admin/labs');
        } catch (err) {
            if (err?.status === 409) toast.error('Ya existe un laboratorio con ese nombre');
            else if (err?.fields) { setServerFields(err.fields); toast.error('Revisá los campos marcados'); }
            else toast.error(err?.message || 'No se pudo crear el laboratorio');
        }
    };

    return (
        <form className="cat-form" onSubmit={handleSubmit}>
            <header className="cat-form__header">
                <Link to="/admin/labs" className="cat-form__back">Laboratorios</Link>
                <h1 className="cat-form__title">Nuevo laboratorio</h1>
            </header>

            <LabFields form={form} setField={setField} fieldError={fieldError} disabled={isPending} />

            <footer className="cat-form__footer">
                <Link to="/admin/labs" className="cat-form__cancel">Cancelar</Link>
                <button type="submit" className="cat-form__submit" disabled={isPending || !form.name.trim()}>
                    {isPending ? 'Creando…' : 'Crear laboratorio'}
                </button>
            </footer>
        </form>
    );
}
